/**
 * Route-level switch between the White Glove and POP Authority versions of a screen.
 *
 * Both account families share the same route names and paths (so every existing router-link and
 * backend `primary_cta_route` keeps working); the component rendered behind a route is chosen
 * from the account type in effect (`isPopAuthorityUser` store getter, sub-account aware).
 * Nothing renders until the user is loaded, so the White Glove screen never flashes before the
 * POP Authority one on first paint.
 */
export function familySwitch ({ whiteGlove, popAuthority, name = 'FamilySwitch' }) {
  return {
    name,
    functional: true,
    render (h, context) {
      const store = context.parent.$store
      if (!store || !store.state.user) return null
      const component = store.getters.isPopAuthorityUser ? popAuthority : whiteGlove
      return h(component, context.data, context.children)
    },
  }
}
